<template>
    <div>
        <div :class="show ? '' : 'abstract'" transition="slide-x-reverse-transition" ref="desWrapper">
            <div class="item" ref="desCription">
                <p class="pl-3 pr-3">{{ text }}</p>
                <v-img :src="url" v-for="url in images" min-height="200px" v-if="url"></v-img>
            </div>
        </div>
        <div class="ml-3">
            <v-btn icon @click="show = !show" v-show="showMoreBtn">
                <v-icon>{{ show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                <span>{{ show ? '收起' : '展开' }}</span>
            </v-btn>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                showMoreBtn: false,
                show: false
            }
        },
        props: ['text', 'images'],
        mounted() {

        },
        computed: {},
        methods: {},
        watch: {
            text: function () {
                this.$nextTick(() => {
                    this.showMoreBtn = parseInt(window.getComputedStyle(this.$refs.desWrapper).height.slice(0, -2)) < parseInt(window.getComputedStyle(this.$refs.desCription).height.slice(0, -2))
                })
            },
            images: function () {
                this.$nextTick(() => {
                    this.showMoreBtn = parseInt(window.getComputedStyle(this.$refs.desWrapper).height.slice(0, -2)) < parseInt(window.getComputedStyle(this.$refs.desCription).height.slice(0, -2))
                })
            },
        },
    }
</script>

<style lang="scss">
    .abstract {
        max-height: 20vh;
        overflow: hidden;
    }

    .item {
        margin-bottom: 20px;
        white-space: pre-wrap;
    }
</style>
